import { CHRIST_DETAILS } from "./christDetails";

export const CHRIST_PRODUCTS = [
    {
        key: "alpha",
        name: "ALPHA",
        type: "Portale di lavaggio",
        target: "Stazioni di servizio, concessionarie, centri di lavaggio",
        img: "/christ/alpha.jpg",
        summary:
            "Il portale collaudato di Christ: bassi costi operativi, ridotto consumo di acqua ed elevata affidabilità, con il nuovo design BLADE SLIM.",
        features: [
            "Linea di design BLADE riconoscibile e illuminata",
            "Basse emissioni acustiche e consumi ridotti di energia e acqua",
            "Costruzione modulare personalizzabile in base al sito",
            "Elevata produttività di lavaggio e tempi di attesa ridotti",
            "Abbinabile agli impianti di trattamento acque Christ",
        ],
        page: "https://www.christ-ag.com/it/impianti-di-lavaggio/portali-di-lavaggio/alpha/",
    },
    {
        key: "cadis",
        name: "CADIS",
        type: "Portale di lavaggio",
        target: "Concessionarie auto e siti ad alta frequenza",
        img: "/christ/cadis.jpg",
        summary:
            "Il portale più veloce di Christ: volumi di lavaggio superiori del 45%, funzionamento silenzioso e dotazione modulare.",
        features: [
            "Display bilaterale a colori VISUS per il posizionamento del veicolo",
            "Linee di design STRIPE e BLADE, colori personalizzabili",
            "Pittogrammi configurabili (5, 6 o 8) a destra o a sinistra",
            "Versione CADIS PREMIUM con effetto spettacolare di prima classe",
        ],
        page: "https://www.christ-ag.com/it/impianti-di-lavaggio/portali-di-lavaggio/cadis/",
    },
    {
        key: "vega",
        name: "VEGA",
        type: "Portale di lavaggio premium",
        target: "Centri di lavaggio e stazioni di servizio con massime esigenze",
        img: "/christ/vega.jpg",
        summary:
            "Il portale premium per le massime esigenze: basse emissioni, elevata produttività e design moderno. Vincitore del Red Dot Design Award 2021.",
        features: [
            "Red Dot Design Award Winner 2021",
            "Costruzione modulare adattabile alla sede",
            "Consumi e costi di manutenzione ridotti",
            "Disponibile anche in versione VEGA XL per veicoli alti",
            "Opzioni Protect Shine Xpress e Foam Splash",
        ],
        page: "https://www.christ-ag.com/it/impianti-di-lavaggio/portali-di-lavaggio/vega/",
    },
    {
        key: "neox",
        name: "NEOX",
        type: "Portale compatto",
        target: "Concessionarie, officine e stazioni di servizio con spazi ridotti",
        img: "/christ/neox.jpg",
        summary:
            "Portale compatto per il 98% dei modelli di autovettura: lavaggio affidabile a un prezzo equo, progettato per sedi compatte con esigenze professionali.",
        features: [
            "Altezza di lavaggio 2,05 m (circa il 98% delle auto più diffuse)",
            "Software di controllo Christ PHOENIX di ultima generazione",
            "2 programmi di lavaggio",
            "Avviamento rapido grazie a un'installazione semplice",
        ],
        page: "https://www.christ-ag.com/it/impianti-di-lavaggio/portali-di-lavaggio/neox/",
        pdf: "/christ/pdf/neox-de.pdf",
        pdfLabel: "Brochure NEOX (DE)",
    },
    {
        key: "flux",
        name: "FLUX",
        type: "Portale touchless",
        target: "Centri di lavaggio, aree premium, veicoli sensibili ai graffi",
        img: "/christ/flux.jpg",
        summary:
            "Il portale senza spazzole: pulizia ad alta pressione senza contatto, per clienti esigenti e veicoli delicati.",
        features: [
            "Lavaggio touchless senza intervento delle spazzole",
            "Chimica alcalina e acida su tetto e fianchi",
            "Ausilio di asciugatura e lavaggio a osmosi",
            "Ideale in abbinamento a un portale classico o a un parco self-service",
        ],
        page: "https://www.christ-ag.com/it/impianti-di-lavaggio/portali-di-lavaggio/flux/",
    },
    {
        key: "big-bertha",
        name: "BIG BERTHA",
        type: "Portale ibrido",
        target: "Centri di lavaggio e location di prestigio",
        img: "/christ/big-bertha.jpg",
        summary:
            "Unisce lavaggio senza contatto e a spazzole in un unico impianto: più programmi, maggiore produttività, più fatturato.",
        features: [
            "Fino al 30% di produttività in più",
            "Adatto anche a SUV e furgoni",
            "Fino a 20 programmi di lavaggio, unico sul mercato",
            "Ridotto consumo di acqua ed energia",
        ],
        page: "https://www.christ-ag.com/it/impianti-di-lavaggio/portali-di-lavaggio/big-bertha/",
        pdf: "/christ/pdf/big-bertha-it.pdf",
        pdfLabel: "Brochure BIG BERTHA (IT)",
    },
    {
        key: "evo-star",
        name: "EVO STAR",
        type: "Tunnel di lavaggio",
        target: "Autolavaggi ad alto volume e investitori",
        img: "/christ/evo-star.jpg",
        summary:
            "Il tunnel modulare per massimi volumi di lavaggio: fino a 120 veicoli all'ora, a risparmio energetico e ampliabile individualmente.",
        features: [
            "Fino a 120 veicoli/ora",
            "Sistema modulare assemblato sulle esigenze individuali",
            "Arco di ingresso personalizzabile, BLADE animato e testo scorrevole",
            "Prespruzzo, rilevamento automatico del veicolo, Foam Wall",
            "Design minimalista ed elegante",
        ],
        page: "https://www.christ-ag.com/it/impianti-di-lavaggio/tunnel-di-lavaggio/evo-star/",
    },
    {
        key: "self-service",
        name: "BLADE / SKIP",
        type: "Impianti self-service",
        target: "Parchi lavaggio e stazioni di servizio",
        img: "/christ/self-service.jpg",
        summary:
            "Carpenteria metallica e sistemi container Christ per il lavaggio self-service: modulari, predisposti per il fotovoltaico e personalizzati.",
        features: [
            "Struttura in acciaio BLADE con illuminazione",
            "BLADE SOLAR: copertura con moduli fotovoltaici in vetro",
            "Sistemi container SKIP con tecnica pre-assemblata",
            "Fino al 70% di risparmio energetico, di acqua e di chimica",
        ],
        page: "https://www.christ-ag.com/it/impianti-di-lavaggio/piste-self-service/",
    },
    {
        key: "nova",
        name: "NOVA / SUPERNOVA",
        type: "Lavaggio camion e autobus",
        target: "Spedizionieri, trasporto pubblico, centri di lavaggio conto terzi",
        img: "/christ/camion.jpg",
        summary:
            "Impianti completamente automatici per veicoli commerciali: NOVA con riconoscimento automatico degli specchietti, SUPERNOVA a 5 spazzole per il lavoro a turni.",
        features: [
            "Adatti a camion, autobus a pianale ribassato, camper",
            "Pressione delle spazzole a controllo elettronico",
            "Principio semi-stazionario: il conducente resta a bordo",
            "SUPERNOVA: ciclo di lavaggio in circa 2,5 minuti",
        ],
        page: "https://www.christ-ag.com/it/impianti-di-lavaggio/impianti-di-lavaggio-camion-e-autobus/nova/",
    },
];

CHRIST_PRODUCTS.forEach((p) => Object.assign(p, CHRIST_DETAILS[p.key]));
